import { AddressForm } from 'components/address'
import { Button } from 'core/components/button'
import { DateInput } from 'core/components/form/date-input'
import { Field } from 'core/components/form/field'
import { TextInput } from 'core/components/form/text-input'
import { CellPhoneMask, requiredMessage } from 'core/constants'
import { isEmail, isOnlyNumbers } from 'core/helpers/validate'
import { useForm } from 'core/hooks/form'
import React, { useEffect } from 'react'
import { API } from 'service'

export const CustomerUpdateForm = ({ global: { modal, operator }, route, basename }) => {
	const form = useForm(
		{
			displayName: ent => ent.name,
			initialEntity: {
				id: 0,
				cpfCnpj: '',
				name: '',
				birthDate: null,
				phone: '',
				email: '',
				password: '',
				passwordCheck: '',
			},
			validate: values => {
				const errors = {}

				if (!values.name) {
					errors.name = requiredMessage
				}

				if (!values.phone) {
					errors.phone = requiredMessage
				}

				if (!values.email) {
					errors.email = requiredMessage
				} else if (!isEmail(values.email)) {
					errors.email = 'Digite um endereço de e-mail válido.'
				}

				if (!isOnlyNumbers(values.password) && values.password) {
					errors.password = 'A senha deve conter apenas números.'
				}

				if (values.password !== values.passwordCheck) {
					errors.passwordCheck = 'Senhas não coincidem'
				}

				return errors
			},
		},
		route,
	)

	useEffect(() => {
		form.handleFetch({
			action: () => API.get(`customer.key/${operator.user.id}`),
			errorFn: err => modal.alert(err.message),
		})
		// eslint-disable-next-line
	}, [])

	const { entity, errors, touched, handleChange, submitting } = form

	return entity.id === 0 ? (
		'Carregando...'
	) : (
		<div className="kt-portlet">
			<div className="kt-portlet__head">
				<div className="kt-portlet__head-label">
					<span className="kt-portlet__head-icon">
						<i className="kt-font-brand fas fa-user" />
					</span>
					<h3 className="kt-portlet__head-title">Meus Dados</h3>
				</div>
			</div>
			<div className="kt-portlet__body">
				<form
					onSubmit={ev => {
						ev.preventDefault()
						form.handleSubmit(data => {
							API.update('customer', data)
								.then(() => {
									modal.alert('Cadastro atualizado com sucesso.', () =>
										route.history.push(`${basename}`),
									)
								})
								.catch(err => modal.alert(err.message))
								.finally(() => form.setSubmitting(false))
						})
					}}
				>
					<div>
						<div className="row">
							<div className="col-lg">
								<Field label="CPF/CNPJ">
									<TextInput
										customClassName="form-control-xl"
										disabled
										meta={{
											error: errors.cpfCnpj,
											touched: touched.cpfCnpj,
										}}
										onChange={(cpfCnpj, type) =>
											handleChange({
												path: 'cpfCnpj',
												type,
												values: { cpfCnpj },
											})
										}
										value={entity.cpfCnpj}
									/>
								</Field>
							</div>

							<div className="col-lg">
								<Field label="Nome">
									<TextInput
										autoFocus
										customClassName="form-control-xl"
										meta={{
											error: errors.name,
											touched: touched.name,
										}}
										onChange={(name, type) =>
											handleChange({
												path: 'name',
												type,
												values: { name },
											})
										}
										value={entity.name}
									/>
								</Field>
							</div>
						</div>

						<div className="row">
							<div className="col-lg">
								<Field label="Data de Nascimento">
									<DateInput
										customClassName="form-control-xl"
										meta={{
											error: errors.birthDate,
											touched: touched.birthDate,
										}}
										onChange={(birthDate, type) =>
											form.handleChange({
												path: 'birthDate',
												type,
												values: { birthDate },
											})
										}
										value={entity.birthDate}
									/>
								</Field>
							</div>

							<div className="col-lg">
								<Field label="Telefone">
									<TextInput
										customClassName="form-control-xl"
										icon="fas fa-phone"
										mask={CellPhoneMask}
										meta={{
											error: errors.phone,
											touched: touched.phone,
										}}
										onChange={(phone, type) =>
											handleChange({
												path: 'phone',
												type,
												values: { phone },
											})
										}
										type="tel"
										value={entity.phone}
									/>
								</Field>
							</div>

							<div className="col-lg">
								<Field label="E-mail">
									<TextInput
										customClassName="form-control-xl"
										icon="fas fa-at"
										meta={{
											error: errors.email,
											touched: touched.email,
										}}
										onChange={(email, type) =>
											handleChange({
												path: 'email',
												type,
												values: { email },
											})
										}
										type="email"
										value={entity.email}
									/>
								</Field>
							</div>
						</div>

						<div className="row">
							<div className="col-lg">
								<Field label="Senha">
									<TextInput
										customClassName="form-control-xl"
										meta={{
											error: errors.password,
											touched: touched.password,
										}}
										onChange={(password, type) =>
											handleChange({
												path: 'password',
												type,
												values: { password },
											})
										}
										type="password"
										value={entity.password}
									/>
								</Field>
							</div>

							<div className="col-lg">
								<Field label="Confirme a Senha">
									<TextInput
										acceptEnter
										customClassName="form-control-xl"
										meta={{
											error: errors.passwordCheck,
											touched: touched.passwordCheck,
										}}
										onChange={(passwordCheck, type) =>
											handleChange({
												path: 'passwordCheck',
												type,
												values: { passwordCheck },
											})
										}
										type="password"
										value={entity.passwordCheck}
									/>
								</Field>
							</div>
						</div>
					</div>

          <div className="separator" />
          <div className="heading">Endereço</div>
          <AddressForm form={form} />

					<div className="col-lg kt-align-right">
						<Button
							customClassName="btn-secondary"
							disabled={submitting}
							icon="fas fa-arrow-right"
							loading={submitting}
							title="Confirmar"
						/>
					</div>
				</form>
			</div>
		</div>
	)
}
